/*
 * Project: Dynamedics Portal Web
 * Created Date: Monday December 4th 2023
 * Author: KasunKarunasekara
 * -----
 * Last Modified: Monday December 4th 2023 7:48:25 pm
 * Modified By: KasunKarunasekara at <kkarunasekara@mitrai.com>
 * -----
 * Copyright (c) 2023 Mitra Sparks
 * -----
 * HISTORY:
 */

import PropTypes from 'prop-types';
import { useState } from 'react';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
//
import NavbarHorizontal from './NavbarHorizontal';
import MobileSidebar from '../navigation/MobileSidebar';
import { Hidden } from '@material-ui/core';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

// ----------------------------------------------------------------------

HomeLayout.propTypes = {
  children: PropTypes.node
};

export default function HomeLayout({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <RootStyle>
      <NavbarHorizontal onOpenSidebar={() => setOpen(true)} />
      <Hidden lgUp>
        <MobileSidebar
          isOpenSidebar={open}
          onCloseSidebar={() => setOpen(false)}
        ></MobileSidebar>
      </Hidden>
      <MainStyle>{children}</MainStyle>
    </RootStyle>
  );
}
